import {spaService$, systemInfo} from "@/shared-services";
// import {getAppStatus } from "single-spa";

const env = process.env.VUE_APP_ENV;

// Carrier in Command
export function mfRegister(tlToken, isHideAddNewLoadButton) {
  if (!systemInfo.isCommand) {
    return
  }
  // const status = getAppStatus("@tl-mf/carrier");
  // if (status === "MOUNTED") return;
  let commandToken = window.localStorage.getItem("TP_PORTAL_TOKEN_V2");
  commandToken = commandToken && commandToken.replace(/['|"]/g, "");
  spaService$.subscribe(x => {
    x.registerSearchLoad({
      env,
      // token: tlToken,
      tlToken: tlToken,
      commandToken,
      type: "command",
    }, isHideAddNewLoadButton)
  })
}

// TP Wallet in Command 
export function mfWalletRegister(userData){
  if (!systemInfo.isCommand) {
    return
  }
  spaService$.subscribe(x => {
    x.registerTpWallet({
     ...userData,
     type: "command",
    })
  })
}